export function isValidEmail(email) {
    if (!email) {
        return false;
    }

    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    return regex.test(email);
}
